import { useQuery } from "@tanstack/react-query";
import { PublicDirectoryAPI } from "../infrastructure/api/PublicDirectory.api";
import { DirectoryFilters } from "../domain/types";

const DIRECTORY_KEY = "public-directory";

/** `null` means the catalogue is closed: no request is made at all. */
export const useDirectorySearch = (filters: DirectoryFilters | null) =>
    useQuery({
        queryKey: [DIRECTORY_KEY, filters],
        queryFn: async () => {
            const { data } = await PublicDirectoryAPI.search(
                filters as DirectoryFilters
            );
            return data;
        },
        enabled: filters !== null,
    });

export const usePublicProfile = (slug: string | undefined) =>
    useQuery({
        queryKey: [DIRECTORY_KEY, "profile", slug],
        queryFn: async () => {
            const { data } = await PublicDirectoryAPI.profile(slug as string);
            return data;
        },
        enabled: Boolean(slug),
        // A 404 here means unpublished or non-existent, and neither becomes
        // findable by asking again.
        retry: false,
    });
